import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { lendingPartnerDeal } from "assets/properties/properties";
import FindProductType from "helper/FindProductType";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
const PartnerDealCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [partnerName, setPartnerName] = useState("");
  const [partnerNameState, setPartnerNameState] = useState(false);
  const [partnerCodeState, setPartnerCodeState] = useState(false);
  const [partnerDealCode, setPartnerDealCode] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productType, setProductType] = useState("");
  const [partnerData, setPartnerGetData] = useState([]);
  const [selectPartnerCode, setSelectPartnerCode] = useState(params?.code ? params?.code : "");
  const [allPartnerData, setAllPartnerData] = useState([]);
  const [productTypeErrorState, setProductTypeErrorState] = useState(false);
  const [partnerErrorState, setPartnerErrorState]= useState(false)
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (partnerName === "") {
      setPartnerNameState(true);
    } else {
      setPartnerNameState(false);
    }
     if (selectPartnerCode === "") {
      setPartnerErrorState(true);
    } else {
      setPartnerErrorState(false);
    }
      if (productType === "") {
      setProductTypeErrorState(true);
    } else {
      setProductTypeErrorState(false);
    }
    if (partnerName && productType && selectPartnerCode) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (params.partnerId) {
      GetData();
    }
  }, [params?.partnerId]);

  const partnerGetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PARTNER_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const partnerDeal = result?.data?.filter((item) => !item?.self && item?.active);
      setPartnerGetData(partnerDeal);
      setAllPartnerData(result?.data);
      FindProductType(
        apiHandler,
        endpoint,
        authToken,
        setProductTypeList,
        setProductType
      );
    }
  };

  const selfCode = allPartnerData?.filter((item) => item?.self === true);
  useEffect(() => {
    partnerGetData();
  }, []);
  useEffect(() => {
    if (selectPartnerCode && productType) {
      setPartnerDealCode(
        generateName(productType, selfCode?.[0]?.code, selectPartnerCode)
      );
    }
  }, [productType, selectPartnerCode]);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PARTNER_DEAL_GETDATA + params.partnerId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPartnerName(result?.data?.name);
      setPartnerDealCode(result?.data?.code);
      setIsActive(result?.data?.active);
      setProductType(result?.data?.productType);
      setSelectPartnerCode(result?.data?.partnerCode);
    }
  };

  const updateRoleInformation = async () => {
    console.log(isActive,'hjkahkdhs')
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PARTNER_DEAL_UPDATE + params?.partnerId,
      method: "PUT",
      authToken: authToken,
      data: {
        name: partnerName,
        code: partnerDealCode,
        partnerCode: selectPartnerCode,
        productType: productType,
        active: isActive,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const saveRoleInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      name: partnerName,
      code: partnerDealCode,
      partnerCode: selectPartnerCode,
      productType: productType,
      active: isActive,
    };
    const res = await apiHandler({
      url: endpoint.PARTNER_DEAL_CREATE,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const handleroleSubmit = async (event) => {
    console.log(isValidated(), "ashdkahjsk");
    if (isValidated()) {
      toastUpdate("", "", false);
      let status = "";
      if (params.partnerId) {
        status = await updateRoleInformation();
      } else {
        status = await saveRoleInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.partnerId
          ? lendingPartnerDeal?.updateMsg
          : lendingPartnerDeal?.createMsg;
        toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/partnerDeal/${params?.code}/${params?.name}/${params?.id}`);
      }
    }
  };

  const statusUpdate = async (checked) => {
    setIsActive(checked);
  };
  const handleProductType = (e) => {
    setProductType(e);
  };
  const handlePartnerCode = (e) => {
    setSelectPartnerCode(e);
  };
  const handlecancelrole = () => {
    navigate(`/coreservice/partnerDeal/${params?.code}/${params?.name}/${params?.id}`);
  };
  const generateName = (type, self, code) => {
    let productTypeShort;
    if (type.toLowerCase() === "gold loan") {
      productTypeShort = "GL";
    } else if (type.toLowerCase() === "personal loan") {
      productTypeShort = "PL";
    }

    if (self && code) {
      return `${productTypeShort}-${self}-${code}`;
    } else if (self) {
      return `${productTypeShort}-${self}`;
    } else if (code) {
      return `${productTypeShort}-${code}`;
    } else {
      return productTypeShort;
    }
  };

  console.log(selectPartnerCode, productType, "ajkdshakjhsdk");
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            params.partnerId
              ? lendingPartnerDeal?.title2
              : lendingPartnerDeal?.title1
          }
          button1="Save"
          button2=" Cancel"
          button1click={handleroleSubmit}
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Product Type"
              value={productType}
              data={productTypeList}
              setState={handleProductType}
              id="receipt_purpose"
              type="productType"
                error={productTypeErrorState}
              setError={setProductTypeErrorState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Partner Deal Name"
              required
              error={partnerNameState}
              id="lp_min_role"
              value={partnerName || ""}
              setState={setPartnerName}
              setError={setPartnerNameState}
              type="noCapital"
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Partner Name"
              value={selectPartnerCode}
              data={partnerData}
              setState={handlePartnerCode}
              id="receipt_purpose"
              type="partnerName"
              error={partnerErrorState}
              setError={setPartnerErrorState}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Partner Deal Code"
              required
              error={partnerCodeState}
              id="partnerDealCode"
              value={partnerDealCode || ""}
              setState={setPartnerDealCode}
              setError={setPartnerCodeState}
              disabled
              type="noCapital"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <p style={{ fontWeight: "bold", display:'flex', alignItems:'center', gap:'5px' }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={isActive}
                className={classes.checkboxInput}
                onChange={(e) => statusUpdate(e.target.checked)}
                style={{width:'20px', height:'20px'}}
              />{" "}
              Active
            </p>
          </Grid>
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default PartnerDealCreate;
